module.exports = __webpack_public_path__ + "media/images/vp/tutorialpopup.3-3d031c1853f9f98fe9a5660ff67ff239.svg";